import Spinner from '../Spinner';

export default function Loading() {
  return (
    <div className="h-screen w-full flex items-center justify-center z-9999">
      <Spinner color="var(--text-1)" />
    </div>
  );
}
